
        <div [formGroup]="stringInfoForm" class="row mt-3 mb-0 form-group">
            <div class=" {{fromQuickCall ? 'col-xl-2 col-lg-2 col-md-4 col-sm-12 col-12' :'col-md-4 col-lg-4 col-xl-4'}}">
                <label class="label" for="stringValueText " id="sd_string_field">
                    {{ customField.displayName }}:
                    <span id="mandatory_field" *ngIf="required && customerEditable">&#42;</span>
                </label>
            </div>
            <div class="{{fromQuickCall ? 'pl-3 col-xl-3 col-lg-3 col-md-7 col-sm-12 col-12' : 'col-md-7 col-lg-6 col-xl-6 col-10'}} sd_custom_input">
                <div *ngIf="stringTypeText">

                    <input class="form-control" type="text" id="sd_string_field_text" formControlName="data" keyup="stringValueUpdate() && patternMatch()"
                        value={{stringValueText}} (focus)="stringFieldFocus = true" (blur)="stringFieldFocus = false" name="data"
                        [ngClass]="{'error-class':( required && stringInfoForm.controls['data'].touched 
                            && stringValueEmpty() && !stringFieldFocus )||
                            (inputValidation && !patternMatch() &&  stringInfoForm.controls['data'].touched && !stringFieldFocus)}"
                        maxlength="255" autocomplete="off">

                    <div *ngIf="inputValidation">
                        ( {{ userMask }} )
                    </div>
                    <div *ngIf="required && stringInfoForm.controls['data'].touched 
                        && stringValueEmpty() && !stringFieldFocus" class="validation-error-inline text-danger">
                        {{ customField.displayName }} {{ 'CustomField.fieldRequired' | translate }}
                    </div>
                    <div *ngIf="( !stringValueEmpty() && inputValidation && !patternMatch() &&  stringInfoForm.controls['data'].touched && stringInfoForm.controls['data'].dirty && !stringFieldFocus)" class="validation-error-inline text-danger">
                        {{ customField.displayName }} {{ 'CustomField.inputNoMatch' | translate }}
                    </div>
                </div>
                <div *ngIf="!stringTypeText">
                    <select class="form-control" id="sd_string_field_list" name="data" (focus)="stringFieldListFocus = true" (blur)="stringFieldListFocus = false"
                        formControlName="data" [ngClass]="{'error-class':(required && stringInfoForm.controls['data'].touched && stringListEmpty() && !stringFieldListFocus) , 'custom-select':customerEditable}">
                        <option></option>
                        <option *ngFor="let list of stringList ; let i = index;trackBy:trackBystring" value="{{list.id}}">{{ list.displayName }}</option>
                    </select>
                    <div *ngIf="required && stringInfoForm.controls['data'].touched && stringListEmpty() && !stringFieldListFocus" class="validation-error-inline text-danger">
                        {{ customField.displayName }} {{ 'CustomField.fieldRequired' | translate }}
                    </div>
                </div>
            </div>

            <span *ngIf="customField.dscEnable === 1" [attr.data-toggle]="customField.fieldId" data-trigger="hover" [attr.data-content]="customField.description"
                class="align_description_icon">
                <em class="fa fa-question-circle fa-lg"></em>
            </span>

        </div>
